import React from 'react';

import styles from './MiaOverview.module.scss';

const SectionTitle = ({ children }) => (
  <div className={styles.sectionTitle}>{children}</div>
);

export default SectionTitle;